import React from "react";
import { Button as MantineButton } from "@mantine/core";

export default function Button({ loading, children = "Submit", leftSection, fullWidth = false, width, align = "left", ...props }) {
  return (
    <MantineButton type="submit" loading={loading} leftSection={leftSection} w={fullWidth ? "100%" : width} {...props}>
      {children}
    </MantineButton>
  );
}
